/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_UPDATE_MASTER_COMPANY,
    REQUEST_UPDATE_MASTER_COMPANY_FAILURE,
    REQUEST_UPDATE_MASTER_COMPANY_SUCCESS
} from "../../../constant/MasterCompanyConstant";

const initialState = {
    updateMasterCompany: {
        data: [],
        isLoading: true,
        status: 'idle'
    },
}

export const updateMasterCompanyReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_MASTER_COMPANY:
            return {
                ...state,
                updateMasterCompany: {
                    data: [],
                    isLoading: true,
                    status: 'fetching'
                }
            };
        case REQUEST_UPDATE_MASTER_COMPANY_SUCCESS:
            return {
                ...state,
                updateMasterCompany: {
                    data: payload,
                    isLoading: false,
                    status: 'ready'
                }
            };
        case REQUEST_UPDATE_MASTER_COMPANY_FAILURE:
            return {
                ...state,
                updateMasterCompany: {
                    data: [],
                    isLoading: false,
                    status: 'failure'
                }
            }
        default:
            return state;
    }
}
